export default "__VITE_ASSET__D3j_0x4b__"